import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AlertBanner } from '../models/alert-banner.model';

@Component({
  selector: 'app-banner-alert',
  templateUrl: './alert-banner.component.html',
  styleUrl: './alert-banner.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AlertBannerComponent {
  @Input({ required: true })
  public alerts: AlertBanner[] | undefined = undefined;
}
